import React, { createContext, useContext, useEffect, useState } from "react";
import { me, getToken, clearToken } from "../api";

const AdminContext = createContext(null);
export const useAdmin = () => useContext(AdminContext);

export function AdminProvider({ children }) {
  const [user, setUser] = useState(null);      // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!getToken()) { setUser(false); setReady(true); return; }
    me().then((u) => { setUser(u); setReady(true); })
        .catch(() => { clearToken(); setUser(false); setReady(true); });
  }, []);

  const logout = () => { clearToken(); setUser(false); };

  return (
    <AdminContext.Provider value={{ user, setUser, ready, logout }}>
      {children}
    </AdminContext.Provider>
  );
}
